import Papa from 'papaparse';
import { FetchError } from '@src/utils/fetch-error';
import {
  CSV_COLUMNS,
  CSV_COLUMNS_WITH_DEVOSCAT,
  DisplayRow,
  StageTwoRow
} from './streaming-ml-diagnostics-constants';

// The lambda 404s when STR-ML-STAGE2 has never produced output for the company.
export const isNoOutputError = (e: unknown): boolean => e instanceof FetchError && e.status === 404;

// Placements look like `<network>_<description>`.
export const getNetwork = (placement: string): string => placement.split('_')[0];

export const toDisplayRows = (rows: StageTwoRow[], showUnseen: boolean): DisplayRow[] =>
  rows
    .filter(row => showUnseen || row.is_seen === 't')
    .map(row => {
      const [network, description = ''] = row.placement.split('_');
      return { ...row, display_name: `${network} ${description}`.trim() };
    });

export const formatNumber = (val: number): string =>
  val.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export const buildCsv = (rows: StageTwoRow[], showDevOSCat: boolean): string => {
  const columns = showDevOSCat ? CSV_COLUMNS_WITH_DEVOSCAT : CSV_COLUMNS;
  return Papa.unparse([columns, ...rows.map(row => columns.map(column => row[column]))]);
};
